import FileService from "./FileService";
import { serializeObject } from "../common/helper";
import { Request, RequestFile } from "./HttpService";
import { translateAndSortAscendant } from "../common/helper";

function serialiazeSearch(searchObject) {
  let keys = Object.keys(searchObject);
  let serializedUrl = "";
  if (keys.length > 0) {
    serializedUrl = "?";
    for (let key of keys) {
      if (
        searchObject[key] !== undefined &&
        searchObject[key] !== null &&
        searchObject[key] !== ""
      ) {
        if (key === "startingDate" || key === "endingDate") {
          if (searchObject[key])
            serializedUrl =
              serializedUrl + `${key}=${searchObject[key].toUTCString()}&`;
        } else if (key === "availabilityStatus") {
          if (searchObject[key].length > 0)
            serializedUrl += serializeList(searchObject, key);
        } else if (key === "skills") {
          if (searchObject[key].length > 0)
           serializedUrl += serializeList(searchObject, key);
        } else if (key === "businessAreas") {
          if (searchObject[key].length > 0)
            serializedUrl =
              serializedUrl +
              searchObject[key].map((item) => key + "=" + item).join("&") +
              "&";
        } else if (key === "tags") {
          serializedUrl = serializedUrl + serializeList(searchObject, key);
        } else serializedUrl = serializedUrl + `${key}=${searchObject[key]}&`;
      }
    }
  }
  return serializedUrl;
}

function serializeList(searchObject, key) {
  if (!searchObject[key] || !Array.isArray(searchObject[key]) || searchObject[key].length === 0) {
    return "";
  }

  return searchObject[key]
    .filter(Boolean)
    .map((item) => `${key}=${item?.id ?? item}`)
    .join("&") + "&";
}

export const InterviewService = {
  getAllAddressZone: function () {
    return Request("vitae/addressZone", "GET");
  },
  generateDocOnline: function (interviewId, generatedLanguageId) {
    return Request(`vitae/interview/generatedoconline`, "POST", {
      interviewId,
      generatedLanguageId
    });
  },
  deleteDraftedInterview(interviewId) {
    return Request(`vitae/interview/${interviewId}`, "DELETE");
  },

  getAllMaritalStatus: function () {
    return Request("vitae/maritalStatus", "GET");
  },

  getAllSchools: function () {
    return Request("vitae/school", "GET");
  },

  getAllCourses: function () {
    return Request("vitae/course", "GET");
  },

  getCourses: function (pageSize, pageNumber, searchData) {
    let url = `vitae/interview/SearchCourses/${pageSize}/${pageNumber}`;
    if (searchData !== undefined) {
      url = url + `?query=${searchData}`;
    }
    return Request(url, "GET");
  },

  getSchools: function (pageSize, pageNumber, searchData) {
    let url = `vitae/interview/SearchSchools/${pageSize}/${pageNumber}`;
    if (searchData !== undefined) {
      url = url + `?query=${searchData}`;
    }
    return Request(url, "GET");
  },

  getAllJobRoles: function () {
    return Request("vitae/jobrole", "GET").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  getAllYearsExperience() {
    return Request("vitae/ProfessionalExperience", "GET");
  },

  getAllSeniorityLevels() {
    return Request("vitae/SeniorityLevel", "GET");
  },

  getAllNationalities() {
    return Request("vitae/nationality", "GET").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  getAllLanguages: function () {
    return Request("vitae/language", "GET").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  getAllLanguageLevels: function () {
    return Request("vitae/languagelevel").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  saveInterview(interview, log) {
    let _interview = { ...interview };

    // don't log event if from tabs
    _interview.log = log;

    _interview.applicationDetail = _interview.applicationDetails
      .filter((x) => x.id === _interview.applicationDetailId)
      .shift();
    _interview.tags = _interview.tags.map((x) => x.id);

    return Request("vitae/Interview", "POST", _interview);
  },

  getInterview(pageSize, pageNumber, searchobject) {
    let url = `vitae/interview/${pageSize}/${pageNumber}`;

    let serializedUrl = serialiazeSearch(searchobject);

    let urlWithSearchParams =
      window.location.protocol +
      "//" +
      window.location.host +
      "/" +
      `interview/${pageSize}/${pageNumber}` +
      serializedUrl;
    window.history.pushState(
      { path: urlWithSearchParams },
      "",
      urlWithSearchParams
    );
    return Request(url + serializedUrl, "GET");
  },

  getRecommended(pageSize, pageNumber, searchobject) {
    let url = `vitae/recommendedinterview/${pageSize}/${pageNumber}`;
    let keys = Object.keys(searchobject);
    if (keys.length > 0) url = url + "?";
    for (let key of keys) {
      if (key === "startingDate" || key === "endingDate") {
        if (searchobject[key])
          url = url + `${key}=${searchobject[key].toISOString()}&`;
      } else url = url + `${key}=${searchobject[key]}&`;
    }
    return Request(url, "GET");
  },

  advanceSearch(searchObject, pageSize, pageNumber) {
    let url = `vitae/InterviewAdvanceSearch/${pageSize}/${pageNumber}`;

    return Request(url, "POST", searchObject);
  },

  getById(id) {
    return Request(`vitae/interview/details/${id}`);
  },
  getDetailsById(id) {
    return Request(`vitae/interview/details/${id}`);
  },

  getEducationInterview(id) {
    return Request(`vitae/interview/getEducationInterview/${id}`);
  },

  getTechnologiesInterview(id) {
    return Request(`vitae/interview/getTechnologiesInterview/${id}`);
  },

  getSkillsInterview(id) {
    return Request(`vitae/interview/getSkillsInterview/${id}`);
  },

  getAllSkills: function () {
    return Request("vitae/personalskill", "GET");
  },

  getAllTechnologies() {
    return Request("vitae/jobroleDetail/tech/tree", "GET").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  getAllMobilityInterview: function () {
    return Request(`vitae/mobility/getAllMobilities`, "GET");
  },

  getAllMobilitiesInterviewReadOnly: function () {
    return Request(`vitae/mobility/getAllMobilitiesReadOnly`, "GET");
  },

  getRemoteWorkOptions: function () {
    return Request("vitae/remoteWorkOptions", "GET");
  },

  getContractType: function () {
    return Request("vitae/contractType", "GET");
  },

  getNoticeOptions: function () {
    return Request("vitae/candidateNoticeInterview", "GET");
  },

  exportToFile(searchParameters, expectecdResults, filename, format) {
    let _searchParameters = { ...searchParameters };
    _searchParameters.expectedNumberOfResults = expectecdResults;
    _searchParameters.format = format;
    let url = "vitae/interview" + serialiazeSearch(_searchParameters);
    return FileService.Download(url, filename);
  },

  GetPrecandidates: function (pageNumber, pageSize, searchObject) {
    return Request(
      `vitae/interview/getPreCandidateFiltered/${pageSize}/${pageNumber}?searchText=${searchObject}`,
      "GET"
    );
  },

  getNumberOfDependents() {
    return Request("vitae/numberofdependant");
  },

  getInterestType: function () {
    return Request("vitae/InterestType", "GET");
  },

  createCandidateProcess: function (parameters) {
    let url = `vitae/interview/createCandidateProcess`;

    let keys = Object.keys(parameters);
    if (keys.length > 0) {
      url = url + "?";

      url = url + serializeObject(parameters);
    }

    return Request(url, "GET");
  },

  checkIfInterviewAlreadyExists: function (parameters) {
    let url = `vitae/interview/checkIfInterviewAlreadyExists`;

    let keys = Object.keys(parameters);
    if (keys.length > 0) {
      url = url + "?";

      url = url + serializeObject(parameters);
    }

    return Request(url, "GET");
  },

  cloneLastInterview: function (interviewId) {
    return Request(`vitae/interview/cloneLastInterview/${interviewId}`, "GET");
  },

  getInterviewHistory: function (interviewId) {
    return Request(`vitae/interview/getInterviewHistory/${interviewId}`, "GET");
  },

  recommendToManager(recommended) {
    return Request("vitae/recommendedInterview/", "POST", recommended);
  },

  GetManagerList: function () {
    return Request("userAccess/User/interview/Managers/", "GET");
  },

  getRecruitersList: function () {
    return Request("userAccess/User/interview/recruiters/", "GET");
  },

  sendDocOnline(params) {
    return Request("vitae/interview/sendDocOnline/", "POST", params);
  },

  getCVs(interviewId) {
    return Request(`vitae/interview/getCVs/${interviewId}`, "GET");
  },

  getOtherDocuments(interviewId) {
    return Request(`vitae/interview/getOtherDocuments/${interviewId}`, "GET");
  },

  getProposalsDocuments(candidateEmail) {
    return Request(`vitae/proposal?Candidate=${candidateEmail}`, "GET");
  },

  getDocOnlineSubmitted(interviewId) {
    return Request(
      `vitae/interview/getDocOnlineSubmitted/${interviewId}`,
      "GET"
    );
  },

  createAutomaticDocOnline(id) {
    return Request("vitae/interview/createAutomaticDocOnline/", "POST", {
      interviewId: id
    });
  },

  uploadDocument: function (document, url) {
    return Request(url, "POST", document);
  },

  GetNumberOfRecommended() {
    return Request("vitae/RecommendedInterview", "GET");
  },

  getSimulation(candidateEmail) {
    return Request(
      `vitae/Simulation?username=&candidateEmail=${candidateEmail}`,
      "GET"
    );
  },

  GetPreviewTechnologiesInterview: function (interviewId) {
    return Request(
      `vitae/Interview/GetPreviewTechnologiesInterview/${interviewId}`,
      "GET"
    );
  },

  DownloadDocOnline: function (
    docOnlineId,
    languageId,
    fileName,
    openInNewTab
  ) {
    const url = `vitae/Interview/DownloadDocOnlineTemplateCurrentCompany/${docOnlineId}/${languageId}`;

    return FileService.Download(url, fileName, openInNewTab);
  },

  getRecommendedManagersByInterview: function (interviewId) {
    return Request(
      `vitae/Interview/getRecommendedManagers/${interviewId}`,
      "GET"
    );
  },

  removeRecommendedManager(managerId, interviewId) {
    return Request("vitae/interview/removeRecommendedManager/", "POST", {
      interviewId: interviewId,
      managerId: managerId
    });
  },

  getPreCandidatesContacts: function (interviewId) {
    return Request(
      `vitae/Interview/getPreCandidatesContacts/${interviewId}`,
      "GET"
    );
  },

  getAlertsToCandidate: function (interviewId) {
    return Request(
      `vitae/Interview/getInterviewAlertsToCandidate/${interviewId}`,
      "GET"
    );
  },

  createContact: function (params) {
    return Request("vitae/Interview/createContact/", "POST", params);
  },

  deleteDocument: function (interviewId, documentId) {
    return Request("vitae/interview/document/", "Delete", {
      interviewId,
      documentId
    });
  },

  getOrganizedTechnologyList: function () {
    return Request("vitae/Technology", "GET").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  getTechnologiesHierachy: function (interviewId) {
    return Request(
      `vitae/Interview/getTechnologiesHierachy/${interviewId}`,
      "GET"
    );
  },

  getAllTechnologiesHierachy: function (interviewId) {
    return Request(`vitae/Interview/getAllTechnologiesHierachy`, "GET");
  },
  deleteFavorite(interviewId) {
    return Request(`vitae/favorite/${interviewId}`, "DELETE");
  },
  addFavorite(interviewId) {
    return Request(`vitae/favorite/${interviewId}`, "POST");
  },
  getMonetary: function () {
    return Request(`vitae/Interview/getMonetary`, "GET");
  },

  getLastDocOnlineState(interviewId) {
    return Request(
      `vitae/Interview/getLastDocOnlineState/${interviewId}`,
      "GET"
    );
  }
};
